<template>
  <div class="jzny-warp">
    <el-date-picker
      :class="!timeData && timeNow ? 'time-picker' : ''"
      format="yyyy-MM"
      value-format="yyyy-MM"
      v-model="timeData"
      type="month"
      prefix-icon="el-icon-date"
      :placeholder="timeNow ? '' : '请选择'"
      style="flex: 1"
      @change="handleChange"
    ></el-date-picker>

    <div class="zj" @click="handleNow" v-if="!isDis">至今</div>
  </div>
</template>
<script>
export default {
  props: ["endTime", "formTimeYz", "nowFlag","isDis"],
  data() {
    return {
      timeData: "",
      timeNow: false,
      timeYz: "",
    };
  },
  mounted() {
    this.timeData = this.endTime || "";
    this.timeNow = this.nowFlag || false;
    this.timeYz = this.timeData || this.timeNow ? "至今" : "";
  },
  methods: {
    handleChange() {
      this.timeNow = false;
      this.timeYz = this.timeData;
      this.updateFun();
    },
    updateFun() {
      this.$emit("update:endTime", this.timeData);
      this.$emit("update:formTimeYz", this.timeYz);
      this.$emit("update:nowFlag", this.timeNow);
    },
    handleNow() {
      this.timeNow = true;
      this.timeData = "";
      this.timeYz = "至今";
      this.updateFun();
    },
  },
};
</script>
<style lang="less" scoped>
.jzny-warp {
  display: flex;
  align-items: center;
  .zj {
    margin-left: 10px;
    color: #409eff;
    cursor: pointer;
  }
}
.time-picker {
  ::v-deep .el-input__inner {
    padding-left: 0.45rem;
  }
  ::v-deep .el-icon-date {
    margin-left: 0.1rem;
    width: 3rem;
    color: #333;
    &::before {
      content: "至今";
    }
    &::after {
      content: "";
    }
  }
}
</style>
